import moment from "moment";
import {
  Action,
  LOAD_MONITORING,
  LOAD_MONITORING_REQUEST,
  LOAD_MONITORING_REQUEST_SUCCESS,
  LOAD_MONITORING_REQUEST_FAIL,
  UPDATE_MONITORING,
  UPDATE_SORT_BY_OPTION,
  LoadMonitoringRequestPayload,
} from "./actionTypes";
import { SortBy } from "../../../components/Analysis/utils/types";

export function updateMonitoring({ siteGroups, composed }: any): Action {
  /* FIXME: argument type */
  return {
    type: UPDATE_MONITORING,
    siteGroups,
    composed,
  };
}

export const updateSortByOption = (sortByOption: SortBy): Action => ({
  type: UPDATE_SORT_BY_OPTION,
  sortByOption,
});

export function loadMonitoring(): Action {
  return {
    type: LOAD_MONITORING,
  };
}

// @FIXME: returning `any` as Saga `put` method does not support our async action.
export const loadMonitoringRequest = ({
  siteIds,
  daysRange = 3,
  token,
}: LoadMonitoringRequestPayload): any => {
  const m = moment();
  const today = m.format("YYYY-MM-DD");
  const range = m.subtract(daysRange, "days").format("YYYY-MM-DD");

  return {
    types: [
      LOAD_MONITORING_REQUEST,
      LOAD_MONITORING_REQUEST_SUCCESS,
      LOAD_MONITORING_REQUEST_FAIL,
    ],
    promise: (client: any) =>
      client.post("/synco/ui/insights", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          from: range,
          to: today,
        },
        data: {
          sites: siteIds,
          insightType: "monitoring",
        },
      }),
  };
};
